<template>
    <div class="fill-height of-y d-flex align-center mr-2" >
        <div class="ml-4 text-h5 font-weight-light">
            Manual Time Approvals
        </div>
        <div class="flex-grow-1">
            <slot></slot>
        </div>
      
        <div>
          <app-toolbar-date-selector :disabled="$store.state.ref.approvals.tabIndex === 0" :range="this.$store.state.ref.dashboard.selectedRange"></app-toolbar-date-selector>
        </div>
      
        <div style="width: 300px">
            <v-text-field
                placeholder="Search"
                hide-details
                class="pa-0 ma-0 mx-2"
                color="primary"
                prepend-inner-icon="mdi-magnify"
                solo
                dense
                v-model="$store.state.ref.approvals.filterStr"
            ></v-text-field>
        </div>
    </div>
</template>

<script>
import AppEmployeeImport from "@/components/Employees/AppEmployeeImport.vue";
import AppToolbarDateSelector from "@/components/Shared/AppToolbarDateSelector.vue";
export default {
    components: {
      AppToolbarDateSelector,
        AppEmployeeImport

    },
    props: {
        shown: Boolean
    },
    data() {
        return {
            showImportEmployees: false
        }
    },
    watch: {

    },
    methods: {

    },
    computed: {

    },
}
</script>

<style scoped>

</style>